export default __webpack_public_path__ + "static/media/PrayerAfternoon.44b4c701.svg";